import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import Button from '../Button';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100vw',
    position: 'absolute',
    left: 0,
    margin: 0,
    borderTop: `1px solid ${theme.palette.common.battleshipGrey}`,
    borderBottom: `1px solid ${theme.palette.common.battleshipGrey}`,
    backgroundColor: theme.palette.common.white,
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    flexWrap: 'wrap',
    padding: '1rem 1.5rem 1.5rem 1rem',
  },
  subMenu: {
    paddingLeft: '1rem',
    borderTop: `1px solid ${theme.palette.common.silver}`,
    borderBottom: `1px solid ${theme.palette.common.silver}`,
  },
  authButton: {
    fontWeight: 500,
    fontSize: '1.2rem',
    margin: '1rem 0',
    width: '10rem',
  },
  textButton: {
    justifyContent: 'flex-start',
    fontWeight: 500,
    fontSize: '1.2rem',
    margin: '0.5rem 0',
    '&:hover': {
      backgroundColor: 'transparent',
      textDecoration: 'underline',
    },
  },
}));

const MobileMenu = ({isAuthenticated, authMenu, setAuthMenu}) => {
  const history = useHistory();
  const classes = useStyles();
  const location = useLocation();
  const redirectTo = location.pathname + location.search;

  const [showMobileServicesMenu, setShowMobileServicesMenu] = React.useState(false);

  const toggleMobileServicesMenu = () => {
    setShowMobileServicesMenu(!showMobileServicesMenu);
  };

  const toggleAuthMenu = value => {
    if (authMenu !== null) {
      setAuthMenu(null);
    } else {
      setAuthMenu(value);
    }
  };

  const handleAuthClick = userType => {
    if (userType === 'participant') {
      if (authMenu === 'login') {
        history.push({pathname: '/login', state:{redirectTo}});
      } else {
        history.push('/signup');
      }
    } else {
      if (authMenu === 'login') {
        history.push({pathname: '/providers', state:{redirectTo}});
      } else {
        history.push('/providers/signup');
      }
    }
    setAuthMenu(null);
    setShowMobileServicesMenu(false);
  };

  return (
    <div className={classes.root}>
      <Container maxWidth="lg" fixed disableGutters={true}>
        <Button
          variant="text"
          color="primary"
          fullWidth
          disableRipple
          label="Services"
          className={classes.textButton}
          onClick={toggleMobileServicesMenu}
        />
        {showMobileServicesMenu ? (
          <div className={classes.subMenu}>
            <Button
              variant="text"
              color="primary"
              fullWidth
              disableRipple
              label="Service matching"
              className={classes.textButton}
              onClick={toggleMobileServicesMenu}
              to="/requestmatch"
            />
            <Button
              variant="text"
              color="primary"
              fullWidth
              disableRipple
              label="Provider search"
              className={classes.textButton}
              to="/search"
            />
            <Button
              variant="text"
              color="primary"
              fullWidth
              disableRipple
              label="Ratings and reviews"
              className={classes.textButton}
              to="/review"
            />
          </div>
        ) : null}
        <Button
          variant="text"
          color="primary"
          fullWidth
          disableRipple
          label="About us"
          className={classes.textButton}
          to="/about"
        />
        <Button
          variant="text"
          color="primary"
          fullWidth
          disableRipple
          label="Blog"
          className={classes.textButton}
          to="/blog"
        />
        <Button
          variant="text"
          color="primary"
          fullWidth
          disableRipple
          label="For providers"
          className={classes.textButton}
          to="/providers"
        />
        {!isAuthenticated ? (
          <React.Fragment>
            <div style={{width: '100%'}}>
              <Button
                variant="contained"
                color="primary"
                disableRipple
                label="Login"
                className={classes.authButton}
                onClick={()=>toggleAuthMenu('login')}
              />
            </div>
            {authMenu === 'login' ? (
              <div className={classes.subMenu}>
                <Button
                  variant="text"
                  color="primary"
                  fullWidth
                  disableRipple
                  label="Log in as a Provider"
                  className={classes.textButton}
                  onClick={()=>handleAuthClick('provider')}
                />
                <Button
                  variant="contained"
                  color="primary"
                  disableRipple
                  label="Log in as an NDIS participant"
                  className={classes.authButton}
                  style={{width: '20rem'}}
                  onClick={()=>handleAuthClick('participant')}
                />
              </div>
            ) : null}
            <div style={{width: '100%'}}>
              <Button
                variant="outlined"
                color="primary"
                disableRipple
                label="Register"
                className={classes.authButton}
                onClick={()=>toggleAuthMenu('signup')}
              />
            </div>
            {authMenu === 'signup' ? (
              <div className={classes.subMenu}>
                <Button
                  variant="text"
                  color="primary"
                  fullWidth
                  disableRipple
                  label="Sign up as a Provider"
                  className={classes.textButton}
                  onClick={()=>handleAuthClick('provider')}
                />
                <Button
                  variant="outlined"
                  color="primary"
                  disableRipple
                  label="Sign up as an NDIS participant"
                  style={{width: '20rem'}}
                  className={classes.authButton}
                  onClick={()=>handleAuthClick('participant')}
                />
              </div>
            ) : null}
          </React.Fragment>
        ) : null }
        {isAuthenticated ? (
          <React.Fragment>
            <div style={{width: '100%'}}>
              <Button
                variant="text"
                color="primary"
                disableRipple
                label="My Profile"
                className={classes.textButton}
                to="/profile"
              />
            </div>
            <div style={{width: '100%'}}>
              <Button
                variant="outlined"
                color="primary"
                disableRipple
                label="Logout"
                className={classes.authButton}
                to="/logout"
              />
            </div>
          </React.Fragment>
        ) : null }
      </Container>
    </div>
  );
};


MobileMenu.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  authMenu: PropTypes.string,
  setAuthMenu: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  return {
    isAuthenticated: state.auth.isAuthenticated,
  };
};

export default connect(mapStateToProps)(MobileMenu);
